// extracted by mini-css-extract-plugin
module.exports = {"imageOverlay":"ImageOverlay_imageOverlay__mqrdK"};